

export const APP_URL = "https://getirbiindirim.herokuapp.com"
// export const APP_URL = "http://127.0.0.1:5000"
